import React from 'react';
import styled from 'styled-components';
import { useLinkComponent } from '../../utils/component';
import { useTranslation } from '../../utils/translation';
import { SponsorType } from '../types';

const Sponsored = styled.div`
  border-radius: 6px;
  border: solid 1px transparent;
  font-style: italic;
  line-height: 26px;
  margin: var(--spacer-s) 0 0;
  padding: 0 var(--spacer-fluid);
`;

interface SponsoredInformType {
  sponsors: SponsorType[];
}

export const SponsoredInform = ({ sponsors }: SponsoredInformType) => {
  const LinkComponent = useLinkComponent();
  const t = useTranslation();

  return (
    <Sponsored>
      {sponsors.length > 0 && <>{t('design.inform.sponsored.introduction')}&nbsp;</>}
      {sponsors.length === 0 && <>{t('design.inform.sponsored.introduction_without_sponsor')}&nbsp;</>}
      {sponsors?.map((sponsor, index) => (
        <>
          <LinkComponent
            key={`sponsor-${index}`}
            className="mod-primary"
            rel={['nofollow']}
            href={sponsor.url}
            openInNewWindow
          >
            {sponsor.title}
          </LinkComponent>
          {index < sponsors.length - 1 ? ', ' : '.  '}
        </>
      ))}
      {t('design.inform.sponsored.read')}&nbsp;
      <LinkComponent
        className="mod-primary"
        href="https://www.clubic.com/clubic/dossier-369336-a-propos-.html"
        openInNewWindow
      >
        {t('design.inform.sponsored.legal')}.
      </LinkComponent>
    </Sponsored>
  );
};
